import { render, staticRenderFns } from "./BackofficeProductionSite.vue?vue&type=template&id=eb116246&"
import script from "./BackofficeProductionSite.vue?vue&type=script&lang=ts&"
export * from "./BackofficeProductionSite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports